import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  TableContainer,
} from "@mui/material";

import { useAppDispatch, useAppSelector } from "../../app/store/configureStore";
import {
  entrezDbSelectors,
  setDbParams,
  updateSelectedDBState,
} from "../../app/store/entrezDbSlice";
import { queryTermFormatter } from "../../app/util/util";

interface Props {
  // queries: QueryLineItem[];
  // onRemove: (field: string) => void;
  //isQuery?: boolean;
  //selectedDB:string
}

export default function SearchHistoryTable() {
  const { dbParams } = useAppSelector((state) => state.entrezDb);

  const dispatch = useAppDispatch();

  const selectedDbWithItsState = useAppSelector((state) =>
    entrezDbSelectors.selectById(state, dbParams.db)
  );

  const handleOnSelectHistoryItem = (index: number) => {
    console.log(index);
    const searchHistory = selectedDbWithItsState!.searchHistory[index];

    dispatch(setDbParams({ term: searchHistory.formattedSearchTerm }));
    console.log(
      "On history search clicked, finalSearchTerm is:" +
        searchHistory.formattedSearchTerm
    );

    //{ id: 'a', changes: { title: 'First (altered)' } }
    dispatch(
      updateSelectedDBState({
        id: dbParams.db,
        changes: {
          queryFields: searchHistory.queryTerms,
          finalFormattedSearchTerm: searchHistory.formattedSearchTerm,
          isReadyForSearch: true,
        },
      })
    );
  };

  const searchHistory = selectedDbWithItsState?.searchHistory;

  console.log(typeof searchHistory);
  console.log(searchHistory);

  return (
    <TableContainer sx={{ maxHeight: 750 }}>
      <Table sx={{ tableLayout: "auto" }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: "5%" }} align="left">
              #
            </TableCell>
            <TableCell sx={{ width: "75%" }} align="left">
              Query
            </TableCell>
           
            <TableCell sx={{ width: "5%" }} align="left">
              Count
            </TableCell>
            <TableCell sx={{ width: "5%" }} align="left">
              Timestamp
            </TableCell>
            <TableCell sx={{ width: "10%" }} align="center">
              <WorkHistoryIcon />
            </TableCell>
          </TableRow>
        </TableHead>

        {searchHistory && searchHistory.length > 0 && (
          <TableBody>
            {searchHistory.map((hItem, index) => (
              <TableRow
                key={index}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell
                  sx={{ width: "5%" }}
                  align="left"
                  component="th"
                  scope="row"
                >
                  {/* <Box display="flex" alignItems="center"> */}
                  <span>{index + 1}</span>
                  {/* </Box> */}
                </TableCell>
                <TableCell sx={{ width: "75%" }} align="left">
                  {hItem.formattedSearchTerm}
                </TableCell>
                <TableCell sx={{ width: "5%" }} align="left">
                  {hItem.count}
                </TableCell>
                <TableCell sx={{ width: "5%" }} align="left">
                  {hItem.timeStamp}
                </TableCell>

                <TableCell sx={{ width: "10%" }} align="center">
                  <Button
                    variant="outlined"
                    size="small"
                    // color="error"
                    onClick={() => {
                      handleOnSelectHistoryItem(index);
                    }}
                  >
                    Search
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>
    </TableContainer>
  );
}
